module.exports = __webpack_public_path__ + "static/media/df (1).091b7909.jpg";